import React from 'react'

import AddressWithViewMapButton from './Common/AddressWithViewMapButton'
import ConfirmationDetails from './Common/ConfirmationDetails'
import Divider from './Common/Divider'
import ItemTypeAndBookedLabel from './Common/ItemTypeAndBookedLabel'
import PlaceholderImage from './Common/PlaceholderImage'
import StartAndEndDateTime from './Common/StartAndEndDateTime'
import SummaryAdditionalNotes from './Common/SummaryAdditionalNotes'
import SummaryDataItem from './Common/SummaryDataItem'
import SummaryImage from './Common/SummaryImage'
import DefaultSummaryModalFooter from './Common/SummaryModalFooter/DefaultSummaryModalFooter'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { CarRentalItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: CarRentalItem
}

function CarRentalItemSummary(props: Props) {
  const { item } = props

  const { closeModal, goBack } = useModalCallbacks()

  const isPickAndDropTheSame =
    item.startPlace.address === item.endPlace?.address

  return (
    <>
      <ModalHeader
        title={item.carType || ''}
        subtitle={item.companyName}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />

      <ModalBody>
        <SummaryImage
          place={item.startPlace}
          placeholder={<PlaceholderImage itemType={item.type} />}
          tripId={item.tripId}
          tripItemId={item.id}
        />
        <ModalContent>
          <VerticalSpacer gap={20}>
            <ItemTypeAndBookedLabel item={item} />
            <StartAndEndDateTime
              startTitle="Pick-up"
              endTitle="Drop-off"
              item={item}
            />
            {isPickAndDropTheSame && item.startPlace.address && (
              <AddressWithViewMapButton
                item={item}
                addressLabel="Pick-up/Drop-off location"
                address={item.startPlace.address}
              />
            )}
            {!isPickAndDropTheSame && item.startPlace.address && (
              <AddressWithViewMapButton
                item={item}
                addressLabel="Pick-up location"
                address={item.startPlace.address}
              />
            )}
            {!isPickAndDropTheSame && item.endPlace?.address && (
              <AddressWithViewMapButton
                item={item}
                addressLabel="Drop-off location"
                address={item.endPlace.address}
              />
            )}
            <ConfirmationDetails
              isBooked={item.isBooked}
              confirmationCode={item.confirmationCode}
              price={item.price}
            />
            <Divider />
            <SummaryDataItem title="Website" value={item.url} url={item.url} />
            <SummaryDataItem
              title="Phone number"
              value={item.phone}
              url={`tel:${item.phone}`}
            />
            <SummaryAdditionalNotes notes={item.notes} />
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>

      <DefaultSummaryModalFooter item={item} />
    </>
  )
}

export default CarRentalItemSummary
